import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function AuthCallback() {
  const navigate = useNavigate();
  const { handleCallback } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const username = params.get('username');
    const error = params.get('error');

    if (error) {
      console.error('OAuth error:', error);
      navigate('/?error=' + error);
      return;
    }

    if (token && username) {
      handleCallback(token, username);
      navigate('/');
    } else {
      console.error('Missing token or username');
      navigate('/?error=missing_credentials');
    }
  }, [handleCallback, navigate]);

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#282c34',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        padding: '20px',
      }}
    >
      <div style={{ fontSize: '24px', marginBottom: '20px' }}>
        Completing sign in...
      </div>
      <div
        style={{
          width: '50px',
          height: '50px',
          border: '5px solid rgba(255, 255, 255, 0.3)',
          borderTop: '5px solid #61dafb',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      />
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default AuthCallback;
